import { useContext } from "react";
import { ConfigContext } from "../context/configProvider";

export const useConfig = () => useContext(ConfigContext);
